export default {
    nonMemberLoader: "/animations/nonMemberLoader.lottie.json",
    memberLoader: "/animations/memberLoader.lottie.json",
}